import { get } from "../utils/request";
// 接口文档 https://nbdoc.fe.qihoo.net/doc/view/6928?sid=78723af4d72c41189892dd0315728b21

// 资漏大屏 -> 获取数据
export const getRiskSummary = (params) => get('/web/scancompliance/riskSummary', params);
